import React from 'react';
import { Form, Modal, Select, Input, Checkbox } from 'antd';
import { COURSE_TYPES, COURSE_TYPE_NAMES } from "../../constants/course-types";
import { COURSE_DAYS_SCHEDULED } from "../../constants/course-days";
import JoditEditor from "jodit-react";
import joditConfig from "./JoditConfig";


class EditCourseForm extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { TextArea } = Input;
        const { visible, onCancel, onOk, form, id, categories } = this.props;
        const { getFieldDecorator } = form;
        console.log(form);

        const courseType = form.getFieldProps("type").value ?? COURSE_TYPES.SCHEDULED;
        // initialize an empty array of course
        // let courseOptions = [];
        return (
            <Modal visible={ visible }
                   title='Edit Course'
                   okText='Save'
                   onCancel={ onCancel }
                   onOk={ onOk }
            >
                <Form layout='vertical'>
                    <Form.Item name='title' item='title' placeholder='Title' label='Title'>
                        { getFieldDecorator('title', {
                            rules: [{ required: true, message: 'Title Required' }],
                        })(<Input/>) }
                    </Form.Item>
                    <Form.Item name='description' item='description' placeholder='Description' label='Description'>
                        { getFieldDecorator('description', {
                            rules: [{ required: false, }],
                        })(<JoditEditor
                            config={ joditConfig }
                        />) }
                    </Form.Item>
                    <Form.Item name='targetAudience' item='targetAudience' placeholder='Target Audience'
                               label='Target Audience'>
                        { getFieldDecorator('targetAudience', {
                            rules: [{ required: true, message: 'Target Audience Required' }],
                        })(<Input/>) }
                    </Form.Item>
                    <Form.Item label='Type'>
                        { getFieldDecorator('type')(
                            <Select onChange={ this.handleTypeChange }>
                                { Object.entries(COURSE_TYPE_NAMES).map(([COURSE_TYPE_VALUE, COURSE_TYPE_NAME]) => {
                                    return (<Select.Option value={ COURSE_TYPE_VALUE }
                                                           key={ COURSE_TYPE_VALUE }>{ COURSE_TYPE_NAME }</Select.Option>)
                                }) }
                            </Select>
                        ) }
                    </Form.Item>
                    {/* Show Day dropdown only if it's a scheduled Course (Day 1, 2, 3, etc)*/ }
                    <Form.Item
                        label="Day"
                        hidden={ courseType !== COURSE_TYPES.SCHEDULED }
                    >
                        { getFieldDecorator('day', { rules: [] })(
                            <Select>
                                { Object.entries(COURSE_DAYS_SCHEDULED).map(([label, value]) => <Select.Option
                                    key={ value } value={ value }>{ label }</Select.Option>) }
                            </Select>
                        ) }
                    </Form.Item>
                    <Form.Item label='Category'>
                        { getFieldDecorator('course_category_id', {
                            rules: [{
                                required: courseType !== COURSE_TYPES.SCHEDULED,
                                message: 'Please select a category'
                            }]
                        })(
                            <Select onChange={ () => false }>
                                <Select.Option value={ null }
                                               key={ "null-value" }>None</Select.Option>
                                { categories.map(({ id, label }) => {
                                    return (<Select.Option value={ id }
                                                           key={ id }>{ label }</Select.Option>)
                                }) }
                            </Select>
                        ) }
                    </Form.Item>
                    <Form.Item
                        label="Active"
                        hidden={ true }
                    >
                        { getFieldDecorator('active', {
                            valuePropName: 'checked'
                        })(
                            <Checkbox/>
                        ) }
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

export default Form.create()(EditCourseForm);
